import { Field, FileField } from '@sitecore-jss/sitecore-jss-nextjs';

export type SoundDemoClip = {
  id: string;
  SoundDemoName: Field<string>;
  SoundDemoFile: FileField;
};

export type SoundDemoEnvironment = {
  id: string;
  EnvironmentName: Field<string>;
  SoundDemoClips: SoundDemoClip[];
};

export type SoundDemoFields = {
  BackgroundColor: Field<string>;
  DisclaimerText: Field<string>;
  Theme: Field<string>;
  SoundDemoEnvironments: SoundDemoEnvironment[];
  trackingSpotName?: Field<string>;
};

export type SoundPlayerProps = {
  isPlaying: boolean;
  onToggle: () => void;
};

export type SoundDemoEnvironmentSelectProps = {
  SoundDemoEnvironments: SoundDemoEnvironment[];
  selectOpen: boolean;
  setSelectOpen: (selectOpen: boolean) => void;
  selectedDemoEnvironment: string;
  setSelectedDemoEnvironment: (selectedEnvironment: string) => void;
  setIsPlaying: (isPlaying: boolean) => void;
};

export type SoundDemoClipComponentProps = {
  SoundDemoEnvironment: SoundDemoEnvironment;
  setSelectedDemoClip: (selectedClip: string) => void;
  theme?: string;
};
